import { useIsFetching, useIsMutating } from '@tanstack/react-query';
import GlobalLoadingIndicator from './GlobalLoadingIndicator';
import { QUERY_KEYS } from '../constants/queryKeys';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import '../scss/_main.scss';

interface Props {
  children: React.ReactNode;
}

const GlobalWrapper: React.FC<Props> = ({ children }) => {
  const { pathname } = useLocation();
  const isMutating = useIsMutating({
    predicate: mutation => {
      const mutationKey =
        mutation.options.mutationKey && mutation.options.mutationKey[0]
          ? mutation.options.mutationKey[0]
          : '';

      // List of mutations that are exempt from global loading.
      return ![QUERY_KEYS.SAVE_OFFER].includes(mutationKey as string);
    }
  });

  const isFetching = useIsFetching({
    predicate: query => {
      // List of queries that are exempt from global loading.
      return ![
        QUERY_KEYS.GET_BANNERS,
        QUERY_KEYS.GET_CATEGORIES_WITH_COUNT,
        QUERY_KEYS.GET_LOCATIONS,
        QUERY_KEYS.GET_OFFERS,
        QUERY_KEYS.GET_SEARCH_SUGGESTIONS,
        QUERY_KEYS.GET_OFFER_PARTNER_LOCATION,
        QUERY_KEYS.GET_OFFER_PARTNER_LOCATIONS_LIST,
        QUERY_KEYS.GET_USER_LOCATION,
        QUERY_KEYS.GET_PARTNERS_WITH_COUNT,
        QUERY_KEYS.GET_SELECTED_PARTNERS,
        QUERY_KEYS.GET_NEWSLETTER
      ].includes(query.queryKey[0] as string);
    }
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <>
      {children}
      {(isFetching > 0 || isMutating > 0) && <GlobalLoadingIndicator />}
    </>
  );
};

export default GlobalWrapper;
